import { render } from "./VehicleRoute.vue?vue&type=template&id=d41d6434"
import script from "./VehicleRoute.vue?vue&type=script&lang=js"
export * from "./VehicleRoute.vue?vue&type=script&lang=js"
script.render = render

export default script